var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectIcon09(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2272_4037)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2272_4037",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6036 7.9054L17.3814 0.415754C16.5236 -0.0719446 15.4656 -0.0719446 14.6079 0.415754L1.38343 7.9054C0.527118 8.39437 3.05176e-05 9.29336 3.05176e-05 10.2658V25.2561C0.00078599 26.2267 0.527849 27.1234 1.38343 27.6099L7.99902 31.3635V39.0166C8.00016 39.3079 8.15925 39.5766 8.41655 39.7217C8.67385 39.8669 8.99044 39.8666 9.24745 39.721L30.6171 27.6165C31.4737 27.1311 32.0011 26.2337 32.0005 25.2628V10.2636C31.9953 9.28958 31.4634 8.39161 30.6036 7.9054Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2272_4037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.987 8.69588L15.998 17.7599L3.05176e-05 8.69588V26.8238L7.99902 31.3525V40.4187L31.987 26.8238V8.69588Z",
    fill: "#EF6C00"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2272_4037",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 40
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6036 7.9054L17.3814 0.415754C16.5236 -0.0719446 15.4656 -0.0719446 14.6079 0.415754L1.38343 7.9054C0.527118 8.39437 3.05176e-05 9.29336 3.05176e-05 10.2658V25.2561C0.00078599 26.2267 0.527849 27.1234 1.38343 27.6099L7.99902 31.3635V39.0166C8.00016 39.3079 8.15925 39.5766 8.41655 39.7217C8.67385 39.8669 8.99044 39.8666 9.24745 39.721L30.6171 27.6165C31.4737 27.1311 32.0011 26.2337 32.0005 25.2628V10.2636C31.9953 9.28958 31.4634 8.39161 30.6036 7.9054Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2272_4037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.998 17.7599L3.05176e-05 8.69588L15.998 -0.368095L31.987 8.69588L15.998 17.7599Z",
    fill: "#FF9800"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2272_4037",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 40
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6036 7.9054L17.3814 0.415754C16.5236 -0.0719446 15.4656 -0.0719446 14.6079 0.415754L1.38343 7.9054C0.527118 8.39437 3.05176e-05 9.29336 3.05176e-05 10.2658V25.2561C0.00078599 26.2267 0.527849 27.1234 1.38343 27.6099L7.99902 31.3635V39.0166C8.00016 39.3079 8.15925 39.5766 8.41655 39.7217C8.67385 39.8669 8.99044 39.8666 9.24745 39.721L30.6171 27.6165C31.4737 27.1311 32.0011 26.2337 32.0005 25.2628V10.2636C31.9953 9.28958 31.4634 8.39161 30.6036 7.9054Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2272_4037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7146 17.4839L0.101255 8.63626L3.05176e-05 8.69588L15.998 17.7599L31.987 8.69588L31.6113 8.47728L15.7146 17.4839Z",
    fill: "#FF9800"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2272_4037",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 40
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6036 7.9054L17.3814 0.415754C16.5236 -0.0719446 15.4656 -0.0719446 14.6079 0.415754L1.38343 7.9054C0.527118 8.39437 3.05176e-05 9.29336 3.05176e-05 10.2658V25.2561C0.00078599 26.2267 0.527849 27.1234 1.38343 27.6099L7.99902 31.3635V39.0166C8.00016 39.3079 8.15925 39.5766 8.41655 39.7217C8.67385 39.8669 8.99044 39.8666 9.24745 39.721L30.6171 27.6165C31.4737 27.1311 32.0011 26.2337 32.0005 25.2628V10.2636C31.9953 9.28958 31.4634 8.39161 30.6036 7.9054Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2272_4037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.998 17.8725V17.7599L0.101255 8.74887L3.05176e-05 8.80849L15.998 17.8725Z",
    fill: "#FF9800"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2272_4037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon09);
export default __webpack_public_path__ + "static/media/project-icon09.ab74f6d2f2a4a3d0555027aa5c334b53.svg";
export { ForwardRef as ReactComponent };